module.exports = __webpack_public_path__ + "static/media/73070007-CuS0wSgs.16d07172.JPG";